/**
 * Normalize an `unknown` thrown value (catch clauses, rejected promises) into a
 * real `Error`. Idempotent for values that are already Errors. Use at the
 * boundary where an unknown reason meets an API that wants an Error (e.g.
 * `Sentry.captureException`, `new Error(msg, { cause })`).
 */
export function toError(value: unknown): Error {
  return value instanceof Error ? value : new Error(String(value));
}

/** Human-readable message from an `unknown` thrown value. */
export function errorMessage(value: unknown): string {
  return value instanceof Error ? value.message : String(value);
}

/** The user/programmatic cancellation error (`Error` / DOMException named `AbortError`). */
export function isAbortError(value: unknown): boolean {
  return value instanceof Error && value.name === 'AbortError';
}
